import { Component, Inject, Input } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './ktostamm-kunde-subnummer.template.html',
    styleUrls: ['./ktostamm-kunde-subnummer.template.scss']
})
export class KtostammKundeSubnummerTemplate implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {
  }
}
